import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { fetchBlogBySlug } from '../../redux/blog/blogSlice';
import { AppDispatch, RootState } from '../../redux';

const useFetchBlogDetails = (id: string) => {
  const dispatch = useDispatch<AppDispatch>();
  const { post, status } = useSelector((state: RootState) => state.blog);

  useEffect(() => {
    dispatch(fetchBlogBySlug(id));
  }, [dispatch, id]);

  return { post, status };
};

export default useFetchBlogDetails;
